import React from 'react';
import { Columns, Column, Container } from '@codeparva/ui-components-library';
import {
  IconDetailsHelper,
  IconDetailsWithBorder,
  IconsDetailsBgImageVariant,
  IconsDetailsBgShapeVariant,
  IconsDetailsTitleBgShapeVariant,
} from './helpers/iconDetailsHelper';
import { WhyChooseUsTypes } from './WhyChooseUsTypes';
import { useWindowDimensions } from '../../../../../utilities/Dimensions';
import { ThemeContext } from './hooks/themeContext';
import { getTextColor } from './helpers/colorSelectorHelper';

export const WhyChooseUs = ({
  variant = 'IconsWithDescription',
  theme,
  title,
  subTitleDetails,
  whyChooseUsIconDetails,
}: WhyChooseUsTypes.IWhyChooseUs) => {
  const { width } = useWindowDimensions();
  const TilesWithColumn = () => {
    return (
      <Columns className="whyChooseUsColumns m-0">
        <Column className="titleAndSubTitleColumn px-0">
          <div
            className={`has-text-${getTextColor(theme)} whyChooseUsTitleDiv`}
          >
            <div className="is-flex">
              <span className="whyChooseUsBorder"></span>
              <h3>{title}</h3>
            </div>
          </div>
          {subTitleDetails.show && (
            <div>
              <p
                className={`has-text-${getTextColor(theme)} ${
                  !subTitleDetails.showOnMobile
                    ? 'is-hidden-mobile'
                    : 'whyChooseUsSubTitle '
                } subtitle2`}
              >
                {subTitleDetails.description}
              </p>
            </div>
          )}
        </Column>
        <Column className="iconsDetailColumn">
          {IconDetailsHelper(width, whyChooseUsIconDetails)}
        </Column>
      </Columns>
    );
  };
  const TilesWithBackgroundShapes = () => {
    return (
      <div className="whyChooseUsBgShapeVariantContainer">
        <IconsDetailsTitleBgShapeVariant
          title={title}
          subTitleDecription={subTitleDetails.description}
        />
        <IconsDetailsBgShapeVariant
          width={width}
          whyChooseUsIconDetails={whyChooseUsIconDetails}
        />
      </div>
    );
  };

  const TilesWithBackgroundImages = () => {
    return (
      <div className="whyChooseUsRightAllignContainer">
        <Columns>
          <Column size={8}>
            <IconsDetailsTitleBgShapeVariant
              title={title}
              subTitleDecription={subTitleDetails.description}
              leftAllign={true}
            />
          </Column>
          <Column size={4}>
            <IconsDetailsBgImageVariant
              width={width}
              whyChooseUsIconDetails={whyChooseUsIconDetails}
            />
          </Column>
        </Columns>
      </div>
    );
  };

  const TilesWithBorderIcons = () => {
    return (
      <div className="whyChooseUsIconsBorderContainer">
        <IconsDetailsTitleBgShapeVariant
          title={title}
          subTitleDecription={subTitleDetails.description}
          leftAllign={true}
        />
        <IconDetailsWithBorder
          width={width}
          whyChooseUsIconDetails={whyChooseUsIconDetails}
        />
      </div>
    );
  };

  const renderVariant = (variantType: WhyChooseUsTypes.TVariantModes) => {
    const variants: WhyChooseUsTypes.TVariantTypes = {
      IconsWithDescription: <TilesWithColumn />,
      IconsCenterAlligned: <TilesWithBackgroundShapes />,
      IconsRightAlligned: <TilesWithBackgroundImages />,
      TilesWithBorderIcons: <TilesWithBorderIcons />,
      default: <TilesWithColumn />,
    };
    return variants[variantType as keyof WhyChooseUsTypes.TVariantTypes];
  };
  const getClassName = () => {
    if (variant === 'IconsRightAlligned' && theme === 'dark') {
      return 'whyChooseUsDivDarkTheme';
    } else if (variant === 'IconsRightAlligned' && theme === 'light') {
      return 'whyChooseUsDivLightTheme';
    } else {
      return theme === 'dark'
        ? 'has-background-primary'
        : 'has-background-secondary';
    }
  };
  return (
    <ThemeContext.Provider value={theme}>
      <div className={`${getClassName()} is-flex`}>
        <Container className="whyChooseUsContainer">
          {renderVariant(variant)}
        </Container>
      </div>
    </ThemeContext.Provider>
  );
};
